var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-lt-cp-resgate-pontos-selecionar-premios',{ref:"listagem"}),_vm._v(" "),_c('vue-element-loading',{attrs:{"active":_vm.loading,"spinner":"bar-fade-scale","is-full-screen":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }